import { FilePreviewStatus } from '@modeso/aumico-lib-cpmm-fe/enums/FilePreviewStatus.enum';
import { createActionGroup, props } from '@ngrx/store';
import { FileMetadataDto } from 'projects/aumico-project-reports/src/app/microservices/ms-annual-reports/financial-closing-process/dto/file-metadata.dto';

export const ComplementaryReportFilesActions = createActionGroup({
    source: 'Complementary Report Files',

    events: {
        'Upload Complementary Report File': props<{
            sortOrderId: number;
            printLocation: string;
            documentFile: FormData;
        }>(),
        'Upload Complementary Report File Success': props<{
            sortOrderId: number;
            printLocation: string;
            document: FileMetadataDto;
        }>(),
        'Upload Complementary Report File Failure': props<{ error: any }>(),

        // Preview Actions as well
        'Check Preview Status': props<{ fileId: string }>(),
        'Check Preview Status Success': props<{ fileId: string; status: FilePreviewStatus }>(),
        'Check Preview Status Failure': props<{ fileId: string; error: any }>(),
        'Request Preview Generation': props<{ fileId: string }>(),
        'Request Preview Generation Success': props<{ fileId: string; requestId: string }>(),
        'Request Preview Generation Failure': props<{ fileId: string; error: any }>(),
        'Load Preview URL': props<{ fileId: string }>(),
        'Load Preview URL Success': props<{ fileId: string; url: string }>(),
        'Load Preview URL Failure': props<{ fileId: string; error: any }>(),

        'Open File': props<{ fileId: string }>(),
        'Open File Success': props<{ fileId: string; url: string }>(),
        'Open File Failure': props<{ fileId: string; error: any }>(),

        'Revoke File URL': props<{ fileId: string }>(),
    },
});
